/**
 * 后台菜单 / 路由名 —— 中文（源语言）
 *
 * ⛔ 设计约定：i18n 的 key 直接用**中文原文**，value 是对应语种。
 *    好处：① 页面里写 fm('确定') 比 formatMessage({id:'btn.ok'}) 直观
 *          ② 漏翻的条目 defaultMessage 兜底为中文，不会出现空白或 key 名泄漏
 *          ③ 中英词典可以逐条对账，差集为零才算翻完
 *
 * menu. 前缀是 Ant Design Pro 的约定（ProLayout 会按 `menu.<name>` 取），
 * 同时保留不带前缀的原文 key 作为兜底（不同版本 umi 取的 id 不一样）。
 */
export default {
  'menu.控制台': '控制台',
  '控制台': '控制台',
  'menu.在线用户': '在线用户',
  '在线用户': '在线用户',
  'menu.角色管理': '角色管理',
  '角色管理': '角色管理',
  'menu.权限管理': '权限管理',
  '权限管理': '权限管理',
  'menu.管理员管理': '管理员管理',
  '管理员管理': '管理员管理',
  'menu.企业管理': '企业管理',
  '企业管理': '企业管理',
  'menu.编辑企业': '编辑企业',
  '编辑企业': '编辑企业',
  'menu.企业管理员': '企业管理员',
  '企业管理员': '企业管理员',
  'menu.导航管理': '导航管理',
  '导航管理': '导航管理',
  'menu.文章分类管理': '文章分类管理',
  '文章分类管理': '文章分类管理',
  'menu.SEO管理': 'SEO管理',
  SEO管理: 'SEO管理',
  'menu.文章管理': '文章管理',
  '文章管理': '文章管理',
  'menu.手工写作': '手工写作',
  '手工写作': '手工写作',
  'menu.编辑文章': '编辑文章',
  '编辑文章': '编辑文章',
  'menu.AI智能写作': 'AI智能写作',
  AI智能写作: 'AI智能写作',
  'menu.全站搜索': '全站搜索',
  '全站搜索': '全站搜索',
  'menu.全球支付': '全球支付',
  '全球支付': '全球支付',
  'menu.会员展示': '会员展示',
  '会员展示': '会员展示',
  'menu.我的企业官网': '我的企业官网',
  '我的企业官网': '我的企业官网',
  'menu.总裁助理': '总裁助理',
  '总裁助理': '总裁助理',
  'menu.敏感词管理': '敏感词管理',
  '敏感词管理': '敏感词管理',
  'menu.短信记录管理': '短信记录管理',
  '短信记录管理': '短信记录管理',
  'menu.引擎管理': '引擎管理',
  '引擎管理': '引擎管理',
  'menu.AI文章成本记录': 'AI文章成本记录',
  AI文章成本记录: 'AI文章成本记录',
  'menu.成本记录': '成本记录',
  '成本记录': '成本记录',
  'menu.企庭中国民营经济网配置': '企庭中国民营经济网配置',
  '企庭中国民营经济网配置': '企庭中国民营经济网配置',
  'menu.公司官网配置': '公司官网配置',
  '公司官网配置': '公司官网配置',
  'menu.区域站点': '区域站点',
  '区域站点': '区域站点',
  'menu.省份管理': '省份管理',
  '省份管理': '省份管理',
  'menu.城市管理': '城市管理',
  '城市管理': '城市管理',
  'menu.区域管理': '区域管理',
  '区域管理': '区域管理',
  'menu.提现审核': '提现审核',
  '提现审核': '提现审核',
  'menu.交易记录': '交易记录',
  '交易记录': '交易记录',
  'menu.通讯录': '通讯录',
  'menu.充值管理': '充值管理',
  'menu.客户系统': '客户系统',
  '通讯录': '通讯录',
  '客户系统': '客户系统',
  '充值管理': '充值管理',

  // 站点标题 / 布局
  'chpen.com 管理后台': 'chpen.com 管理后台',
  '管理后台': '管理后台',
  '注销名册': '注销名册',
};
